import { useMemo, type CSSProperties, type ReactNode } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { cn } from "@tellescope/design-system";
import { BlockSortableContext } from "./block-sortable-context";

export interface BlockSortableProviderProps {
  sortableId: string;
  children: ReactNode;
}

export const BlockSortableProvider = ({ sortableId, children }: BlockSortableProviderProps) => {
  const { listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: sortableId });

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const value = useMemo(() => ({ listeners, isDragging }), [listeners, isDragging]);

  return (
    <BlockSortableContext.Provider value={value}>
      <div ref={setNodeRef} style={style} className={cn(isDragging && "opacity-40 pointer-events-none")}>
        {children}
      </div>
    </BlockSortableContext.Provider>
  );
};
